import HeroStatic from "./HeroStatic";

/**
 * Hero component - renders the rebrand announcement hero section
 */
const Hero = () => {
  return <HeroStatic />;
};

export default Hero;
